import { useEffect, useState } from "react";
import { CollectiblesNavigationIcon, CryptoNavigationIcon, GemsNavigationIcon, PowerUpNavigationIcon } from "../ui/secondary-navigation-icons.component";
import { useTheme } from '@mui/material/styles';
import { useGetTournamentLeagueRewardsQuery} from "../../apis/tournaments.api";
import { LeagueType } from "./league.component";
import { computeRewardVisibleIcons, RewardVisibleIcons } from "../../utils/RewardsUtils";

interface RankRewardProps {
  icons: RewardVisibleIcons,
  darkMode: boolean,
}

const RankReward: React.FC<RankRewardProps> = ({darkMode=false, icons}) => {

  const theme = useTheme();

  const color = darkMode ? "white" : theme.palette.primary.main;

  return (
    <div className="flex flex-wrap w-12 h-12 items-center justify-center">
      <CollectiblesNavigationIcon h={icons.collectible ? 20 : 0} color={color}/>
      <CryptoNavigationIcon h={icons.crypto ? 20 : 0} color={color}/>
      <GemsNavigationIcon h={icons.gems ? 20 : 0} color={color}/>
      <PowerUpNavigationIcon h={icons.powerUp ? 20 : 0} color={color}/>
    </div>
  );
}

export default RankReward;